import React from "react";
import Error from "../../utils/alert/error/Error";
import SelectEquipmentType from "./SelectEquipmentType";
import ValidationButton from "../../utils/buttons/ValidationButton";
import SelectEquipmentExplanation from "../../utils/alert/explanation/SelectEquipmentExplanation";
import {EEquipmentType} from "../../../models/utils/EEquipmentType";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    initialEquipmentType?: EEquipmentType,
    onValidate: (equipmentType: EEquipmentType) => void,
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/05/2022
 * @last_update 16/05/2022
 **/
class SelectEquipmentTypeStep extends React.Component<Props> {

    state = {
        isError: false,
        currentEquipmentType: this.props.initialEquipmentType
    }

    render() {

        const setEquipmentType = (equipmentType: EEquipmentType) => {
            if(equipmentType in EEquipmentType) {
                this.setState({isError: false, currentEquipmentType: equipmentType});
            } else {
                this.setState({isError: true});
            }
        }

        const onValidate = () => {
            const equipmentType = this.state.currentEquipmentType;
            if(equipmentType !== undefined && equipmentType in EEquipmentType) {
                this.props.onValidate(equipmentType);
            } else {
                this.setState({isError: true});
            }
        }

        return (

            <div className="step-main-container">
                <SelectEquipmentExplanation/>
                {
                    this.state.isError ? (
                        <Error>
                            {this.props.t("steps.select.error")}
                        </Error>
                    ) : ""
                }
                <div className="form-container">
                    <SelectEquipmentType
                        equipmentType={this.state.currentEquipmentType}
                        setEquipmentType={setEquipmentType}
                    />
                </div>
                <div className="validation-container">
                    <ValidationButton onClick={onValidate}/>
                </div>
            </div>

        );

    };

}

export default withTranslation()(SelectEquipmentTypeStep);
